/**
 * Color Theme Switcher - 컬러 테마 선택 컴포넌트
 */

import React from 'react';
import { useColorTheme, ColorTheme } from '../contexts/ColorThemeContext';
import './ColorThemeSwitcher.css';

const ColorThemeSwitcher: React.FC = () => {
  const { colorTheme, setColorTheme } = useColorTheme();

  const themes: { value: ColorTheme; label: string; icon: string }[] = [
    { value: 'sage-green', label: '🌿 Sage Green', icon: '🌿' },
    { value: 'ocean-blue', label: '🌊 Ocean Blue', icon: '🌊' },
    { value: 'sunset-orange', label: '🌅 Sunset Orange', icon: '🌅' },
    { value: 'purple-night', label: '🌙 Purple Night', icon: '🌙' },
  ];

  return (
    <div className="color-theme-switcher">
      <select 
        value={colorTheme} 
        onChange={(e) => setColorTheme(e.target.value as ColorTheme)}
        className="theme-select"
        title="컬러 테마 선택"
      >
        {themes.map((theme) => (
          <option key={theme.value} value={theme.value}>
            {theme.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ColorThemeSwitcher;
